<template>
  <div class="start" :style="box">
      <div class="bg"  :style="imgSize"></div>
      <img class="yun1" src="../assets/yun1.png" :style="yun1">
      <img class="yun2" src="../assets/yun2.png" :style="yun2">
      <div class="title">
          <p class="Headlines">LBS Mini Marketing</p>
          <p class="subtitle">位置营销小挑战</p>
          <div class="btn-wrap">
          <a  @mousemove="move($event)" class="button"><span></span><b><router-link clickMusic='true' to="/howtoplay">start</router-link></b></a>
          </div>
          <img src="../assets/logo.svg" class="logo" />
      </div>
       <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'HelloWorld',
  data () {
    return {
      imgSize:{
        width:'',
        height:'',
        transform:''
      },
      yun1:{
        top:''
      },
      yun2:{
        bottom:''
      },
      box:{
        width:'',
        height:''
      },
      image:0,
      image2:0,
      timer:null,
      timerI:null,
    }
  },
    watch: {
    image: function (val) {

        if(val>99){
          clearInterval(this.timer);
         let h = window.innerHeight+100
         let w = window.innerWidth+100
         let i =val;
         let a =this.yun1.top
         let b =this.yun2.top

         let yun = parseFloat(a.replace(/^[^\d]*(\d+)[^\d]*$/, "$1"))
         let yun1 = parseFloat(b.replace(/^[^\d]*(\d+)[^\d]*$/, "$1"))
          yun1 = yun1
         let self = this;
            this.timer = null
            this.timerI =  setInterval(function(){
            i--
            w--
            h--
            yun--
            yun1++
            self.image2 = i
            self.imgSize.width = w+'px'
            self.imgSize.height = h+'px'
            self.imgSize.marginLeft = -i+'px'
            self.imgSize.marginTop = -i+'px'
            self.yun1.top=yun+'px'
            self.yun2.top=yun1+'px'
          },100)

        }
    },
    image2:function(val){
       if(val < 1){
              clearInterval(this.timerI);
      this.timerI = null

         let h = window.innerHeight
         let w = window.innerWidth
         let i =0;
         let yun = h*0.616;
         let yun1 = -(h*0.205);
         let self = this;
         this.timer =  setInterval(function(){
            i++
            w++
            h++
            yun++
            yun1--
            self.image = i
            self.imgSize.width = w+'px'
            self.imgSize.height = h+'px'
            self.imgSize.marginLeft = -i+'px'
            self.imgSize.marginTop = -i+'px'
            self.yun1.top=yun+'px'
            self.yun2.top=yun1+'px'
          },100)
       }
    }
  },
  methods:{
     getFullPx(){
         let h = window.innerHeight
         let w = window.innerWidth
         this.imgSize.width = w+'px'
         this.imgSize.height = h+'px'
         this.box.width =w+'px'
         this.box.height =h+'px'
         let i =0;
         let yun = h*0.616;
         let yun1 = -(h*0.205);
         let self = this;
         this.timer =  setInterval(function(){
            i++
            w++
            h++
            yun++
            yun1--
            self.image = i
            self.imgSize.width = w+'px'
            self.imgSize.height = h+'px'
            self.imgSize.marginLeft = -i+'px'
            self.imgSize.marginTop = -i+'px'
            self.yun1.top=yun+'px'
            self.yun2.top=yun1+'px'
          },100)







     },
     move(e){

     const x = e.pageX - e.target.offsetLeft
     const y = e.pageY - e.target.offsetTop

      e.target.style.setProperty('--x', `${ x }px`)
      e.target.style.setProperty('--y', `${ y }px`)


     }
  },
  created(){
    this.getFullPx();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #fff;
  text-decoration: none;
}

.start{width: 100%;position: relative;overflow: hidden;}
.start .bg {position: absolute;background: url('../assets/bg.jpg') no-repeat ;background-size:cover;}
.start .yun1,.start .yun2{position: absolute;}
.start .yun1{top:386px;}
.start .yun2{bottom: -386px;}
.start .title{position: absolute;width: inherit;height: inherit;}
.start .title .Headlines,.start .title .subtitle{font-size: 70px;color: #fff;font-weight: bold;width: 100%;position: fixed;text-align: center; }

.start .title .Headlines
{
top:20%;
animation: myfirst 5s;
-moz-animation: myfirst 5s; /* Firefox */
-webkit-animation: myfirst 5s;  /* Safari 和 Chrome */
-o-animation: myfirst 5s; /* Opera */
}

.start .title .subtitle{
    opacity: 0.8;
    top: 39%;
    font-size: 40px;
    font-weight: 600;
    animation: subtitle 3s;
-moz-animation: subtitle 3s; /* Firefox */
-webkit-animation: subtitle 3s;  /* Safari 和 Chrome */
-o-animation: subtitle 3s; /* Opera */

}

@keyframes myfirst
{
0%   {opacity: 0.2;top:10%;}
25%  {opacity: 0.8;top:20%;}
50%  {opacity: 0.9;top:20%;}
100% {opacity: 1;top:20%;}
}


@keyframes subtitle
{
0%   {opacity: 0;top:35%;}
25%  {opacity: 0;top:35%;}
50%  {opacity: 0.7;top:39%;}
100% {opacity: 0.9;top:39%;}
}

.btn-wrap{
  text-align: center;
  padding-top:31%;
      animation: btnWrap 4s;
-moz-animation: btnWrap 4s; /* Firefox */
-webkit-animation: btnWrap 4s;  /* Safari 和 Chrome */
-o-animation: btnWrap 4s; /* Opera */

}


@keyframes btnWrap
{
0%   {opacity: 0;padding-top:28%;}
25%  {opacity: 0;padding-top:28%;}
50%  {opacity: 0.9;padding-top:31%;}
100% {opacity: 1;padding-top:31%;}
}

.button {
  position: relative;
  appearance: none;
  background: #0575e6;
  padding: 12px;
  border: none;
  color: white;
  font-size: 30px;
  cursor: pointer;
  outline: none;
  overflow: hidden;
  border-radius: 100px;
  display: inline-block;
  width: 14%;
  text-align: center;

}

 .button   span {
    position: relative;
  }
   .button  b {
    position: relative;
    z-index: 3
  }
  .button:before {
    --size: 0;
    content: '';
    position: absolute;
    left: var(--x);
    top: var(--y);
    width: var(--size);
    height: var(--size);
    background: radial-gradient(circle closest-side, #021b79, transparent);
    transform: translate(-50%, -50%);
    transition: width .2s ease, height .2s ease;
  }
  .button:hover,.button:before {
    --size: 400px;
  }

  .logo{position: absolute;top:0;left: 0;display: block;}

  </style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue